import { DragCountStyled } from "./DragCount.styled";

interface IProps {
  count: number;
}

export const DragCount = ({ count }: IProps) => {
  return <DragCountStyled>{count}</DragCountStyled>;
};
